import {useEffect} from 'react';

// TODO: 문제 없다면 이 훅은 제거하고 useBlockWindowScroll 훅 사용하자.
export default function useBlockBodyScroll(isBlock: boolean) {
  useEffect(() => {
    if (isBlock) document.body.style.overflow = 'hidden';
    else document.body.style.removeProperty('overflow');

    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, [isBlock]);
}
